import AuthLogin from '../views/login';
import MainLayout from '../components/layout';


const LoginRoutes = {
    path: '/Login',
    element: (
          <MainLayout />
      ),
    children: [
        {
            path: '/Login',
            element: <AuthLogin />
        }

    ]
};

export default LoginRoutes;